import { render, staticRenderFns } from "./AppealStatistics.vue?vue&type=template&id=eca78532"
import script from "./AppealStatistics.vue?vue&type=script&lang=js"
export * from "./AppealStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports